module.exports = __webpack_public_path__ + "img/example-4.2c354434.png";